

export const APP_CONSTANTS = {
    // App Name
    APP_NAME: 'EatLaza',

    // App Version
    APP_VERSION: '1.6.0',

    // app from type
    APP_FROM: 'main_admin',

    // default public email 
    DEFAULT_EMAIL: 'hello@eatlaza.com',

    // email for support 
    SUPPORT_EMAIL: 'hello@eatlaza.com',

    // whatsapp number for support
    WHATSAPP_NUMBER: '918004939971',

    // API Endpoints
    API_BASE_URL:
    process.env.NODE_ENV === 'development'
      ? 'http://192.168.1.13:5000/api/v1'
      : 'https://api.eatlaza.com/api/v1',

    // API_BASE_URL: 'https://api.eatlaza.com/api/v1',

};